// Paste your real Cents / Laundroworks booking URLs here when ready.
// Buttons linked here open the booking portal in a new tab.
export const BOOKING_LINKS = {
  pickupDelivery: "https://order.spintasticcity.com/order/business/OXE3",
};

// Set an ISO date string (e.g. "2026-11-15T09:00:00") once the grand
// reopening date is announced — the banner will show a live countdown.
// Leave empty to show the "date coming soon" announcement.
export const GRAND_OPENING_DATE = "";
